export default __webpack_public_path__ + "static/media/pro3m.e0a5de87.png";